import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=248cc51c&scoped=true&"
import script from "./TemplateDetail.vue?vue&type=script&lang=js&"
export * from "./TemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&id=248cc51c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cc51c",
  null
  
)

export default component.exports